import { render, staticRenderFns } from "./Novel_List.vue?vue&type=template&id=86d4e876&scoped=true&"
import script from "./Novel_List.vue?vue&type=script&lang=js&"
export * from "./Novel_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d4e876",
  null
  
)

export default component.exports